import { render, staticRenderFns } from "./sdemail.vue?vue&type=template&id=042a198c&scoped=true"
import script from "./sdemail.vue?vue&type=script&lang=js"
export * from "./sdemail.vue?vue&type=script&lang=js"
import style0 from "./sdemail.vue?vue&type=style&index=0&id=042a198c&prod&lang=scss&scoped=true"
import style1 from "./sdemail.vue?vue&type=style&index=1&id=042a198c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042a198c",
  null
  
)

export default component.exports